export enum USER_STATUS {
  ONLINE = "online",
  OFFLINE = "offline",
  AWAY = "away",
}
